<template>
  <div class="popup-form property-popup-form">
      <div class="content-form-popup">
        <div class="property-popup-heading">
            <button type="button" class="property-close-button" aria-label="Zavrieť nehnuteľnosť" @click="closePopup">
              <img class="nav-link-icon filter-primary" src="@/images/modal-close.svg" alt="">
            </button>
            <div class="property-popup-title">
              {{ payload ? "Úprava" : "Pridanie" }} {{ getPropertyDataBySubType(type.child_type).label }}
            </div>
            <button type="submit" form="property-submit" class="property-save-button">Uložiť</button>
        </div>
        <property-form
          :druh="type.druh"
          :type="getPropertyDataBySubType(type.child_type)"
          @property-saved="saveProperty($event)"
          :property="payload"
          :banks="banks"
          :form-template="form"
        />
        <div v-if="cloud && cloud.missingFiles.length > 0">
          <div class="splitter">Podklady</div>
          <document-cloud-handler
            v-for="(missingFile, index) in cloud.missingFiles"
            :key="index"
            :title="missingFile.name"
            :type="missingFile.id"
            :uploaded="missingFile.uploaded"
            :class-cst="'upload-item-broker-custom'"
            :cloud-meta="cloud.cloudMeta"
            :rules="['single']"
            text-button
          />
        </div>
      </div>
  </div>
</template>

<script>
import PropertyForm from "./PropertyForm";
import propertyFilters from "../../../../../mixins/propertyFilters";
import {postChildTypeToPropertyById} from "../../../../../services/brokerService";
import DocumentCloudHandler from "@/components/shared/PopupHandler/Popups/DocumentCloud/DocumentCloudHandler.vue";
import {mapGetters} from "vuex";

export default {
  name: "ClientPropertyPopUp",
  components: {
    DocumentCloudHandler,
    PropertyForm
  },
  props: {
    payload: [Object, null],
    type: Object,
  },
  mixins: [
    propertyFilters,
  ],
  computed: {
    ...mapGetters({
      cloudsGetter: "mortgageDetailCloud/getClouds",
    }),
  },
  watch: {
    cloudsGetter(clouds) {
      if (!this.payload?.cloud) return;
      this.cloud = clouds.find((cloud) => cloud.cloudId === this.payload.cloud);
    }
  },
  created () {
    if (this.payload?.cloud) {
      const clouds = this.$store.getters["mortgageDetailCloud/getClouds"];
      this.cloud = clouds.find((cloud) => cloud.cloudId === this.payload.cloud);
    }
    this.mortgage = this.$store.getters["mortgageDetailState/getMortgage"];
    this.form = this.$store.getters["formStore/getFormByType"]("propertyForm");
    const pBanks = this.$store.getters["formStore/getBanks"];
    for (const bank of pBanks) {
      this.banks.push({display_name: bank.nazov, value: bank.id});
    }
  },
  methods: {
    async saveProperty (propertySaved) {
      if (this.payload) {
        const data = {
          propertyLabel: this.getLabelByType(this.type.druh),
          id: propertySaved.id,
          object: propertySaved.data,
          childData: propertySaved.childData,
        }
        if (!propertySaved.meta.childTypeAlreadySpecified) {
          const newProperty = await postChildTypeToPropertyById({type: propertySaved.meta.childType}, propertySaved.id);
          data.object = {...newProperty, ...data.object};
        }
        this.$store.dispatch("mortgageDetailState/patchProperty", data);
      } else {
        const data = {
          propertyLabel: this.getLabelByType(this.type.druh),
          propertyType: this.type,
          mortgageId: this.mortgage.id,
          object: propertySaved.data,
          childData: propertySaved.childData,
        }
        this.$store.dispatch("mortgageDetailState/createProperty", data);
      }
      this.closePopup();
    },
    closePopup () {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
  },
  data: () => ({
    cloud: null,
    banks: [],
    form: null,
    mortgage: null,
  }),
};
</script>

<style scoped lang="scss">
.property-popup-form {
  width: min(720px, 100vw)!important;
  background:var(--app-bg)!important;
}

.sub-popup-wrapper {
  text-align: center;
  color: #0019d9;
}

.popup {
  position: absolute !important;
  top: 0;
  overflow-y: auto;
  transition-duration: 0.5s;
}

.pop-up-active {
  transform: translateX(0);
}

.header-form-popup {
  border: none;
}

.property-popup-form .content-form-popup { padding:0!important; }
.property-popup-heading { position:sticky; top:0; z-index:5; display:flex; align-items:center; gap:14px; min-height:78px; padding:16px 24px; box-sizing:border-box; border-bottom:1px solid var(--app-border); background:var(--app-surface); }
.property-popup-title { min-width:0; flex:1; font-size:15px; line-height:1.4; font-weight:650; color:var(--app-text); }
.property-close-button { display:grid; place-items:center; flex:0 0 34px; height:34px; padding:0; border:1px solid var(--app-border); border-radius:9px; background:var(--app-surface-muted); cursor:pointer; }
.property-save-button { flex:0 0 auto; padding:10px 16px; border:0; border-radius:9px; background:var(--app-primary); color:var(--app-on-primary,#fff); font:inherit; font-size:12px; font-weight:600; cursor:pointer; }
.property-popup-heading button:focus-visible { outline:2px solid var(--app-primary); outline-offset:2px; }
@media(max-width:480px) { .property-popup-heading { padding:14px;gap:10px; }.property-popup-title { font-size:13px; } }
</style>

<style>
/* The open property drawer owns the screen on mobile. */
@media(max-width:767px) {
  .broker-shell:has(.property-popup-form) .bankari-dock { visibility:hidden; pointer-events:none; }
}
</style>
